export default __webpack_public_path__ + "static/media/36I-117164_-37347_0.6be31325.jpg";